import { useTranslations } from '@vocab/react';

import {
  AI_REPLACE_WITH_AI_CONTENT_DIALOG_CANCEL_BUTTON_PRESSED,
  AI_REPLACE_WITH_AI_CONTENT_DIALOG_NAME,
  AI_REPLACE_WITH_AI_CONTENT_DIALOG_REPLACE_BUTTON_PRESSED,
} from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';
import { CtaDialog } from 'src/app/v1/views/components/CtaDialog';

import translations from './.vocab';

interface Props {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const CTA_DIALOG_ID = 'replace-what-you-entered';

export const ReplaceWhatYouEnteredDialog = ({
  isOpen,
  onCancel,
  onConfirm,
}: Props) => {
  const { t } = useTranslations(translations);

  return (
    <CtaDialog
      id={CTA_DIALOG_ID}
      isOpen={isOpen}
      cancelBtnText={t('replace-what-you-entered-dialog-cancel-btn-text')}
      confirmBtnText={t('replace-what-you-entered-dialog-replace-btn-text')}
      onCancel={() => {
        getTrackingAdapter.sendLinkEvent({
          eventName: AI_REPLACE_WITH_AI_CONTENT_DIALOG_CANCEL_BUTTON_PRESSED,
          objectInteraction: AI_REPLACE_WITH_AI_CONTENT_DIALOG_NAME,
        });

        onCancel();
      }}
      onConfirm={() => {
        getTrackingAdapter.sendLinkEvent({
          eventName: AI_REPLACE_WITH_AI_CONTENT_DIALOG_REPLACE_BUTTON_PRESSED,
          objectInteraction: AI_REPLACE_WITH_AI_CONTENT_DIALOG_NAME,
        });

        onConfirm();
      }}
      title={t('replace-what-you-entered-dialog-title')}
    >
      {t('replace-what-you-entered-dialog-content-text')}
    </CtaDialog>
  );
};
